"use client"

import Image from "next/image"
import Link from "next/link"
import { usePathname } from "next/navigation"
import { ROUTES } from "@/consts"
import {
  faDatabase,
  faHammer,
  faMailbox,
  faSquarePollHorizontal,
} from "@instadeepai/fontawesome-pro-regular"

import { MenuSection } from "./menu-section"
import { UserFooter } from "./user-footer"

export const Sidebar = () => {
  const pathname = usePathname()

  const mainMenuItems = [
    { icon: faDatabase, text: "Modules", id: "modules", href: ROUTES.MODULES },
    { icon: faHammer, text: "Forge", id: "forge", href: ROUTES.FORGE },
  ]

  const accountItems = [
    {
      icon: faSquarePollHorizontal,
      text: "Organization",
      id: "organization",
      href: ROUTES.ORGANIZATION,
    },
  ]

  const helpItems = [
    { icon: faMailbox, text: "Contact", id: "contact", href: ROUTES.CONTACT },
  ]

  return (
    <div className="flex w-[216px] shrink-0 flex-col items-start gap-4 self-stretch rounded-tr-[16px] bg-forge-gradient p-3 pt-6 text-gray-100">
      <div className="flex size-full flex-col justify-between">
        <div className="space-y-4">
          <Link href="/modules">
            <Image
              src="/logo.svg"
              alt="DeepForge Logo"
              width={192}
              height={40}
              priority
            />
          </Link>
          <div className="space-y-3">
            <MenuSection
              title="Main Menu"
              items={mainMenuItems}
              activeItem={pathname}
            />
            <MenuSection
              title="Account"
              items={accountItems}
              activeItem={pathname}
            />
            <MenuSection title="Help" items={helpItems} activeItem={pathname} />
          </div>
        </div>
        <UserFooter firstName="Andy" lastName="Wang" imageSrc="/avatar.svg" />
      </div>
    </div>
  )
}
